import "./TheFirm.module.css";
import Header from "@/reusable_sections/Header";
import OurLegacy from "./sections/OurLegacy";
import DistinguishedCounsel from "./sections/DistinguishedCounsel";
import CoreValues from "./sections/CoreValues";
import Footer from "@/reusable_sections/Footer";
export default function TheFirmPage() {
  return <div>
      <Header />
      <OurLegacy />
      <DistinguishedCounsel />
      <CoreValues />
      <Footer />
    </div>;
}